/** Shared cache for the Chapters list; invalidate after bulk JSON import from the module page. */
export const chaptersCache = {
  chapters: null,
  moduleId: null,
  firstLoad: true,
  lastSearch: undefined,
};

export function invalidateChaptersCache() {
  chaptersCache.chapters = null;
  chaptersCache.moduleId = null;
  chaptersCache.firstLoad = true;
  chaptersCache.lastSearch = undefined;
}

function coerceNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * Optimistically bump "chapter -> units count" in the cached chapters list.
 * This keeps Chapter cards up-to-date immediately after adding/deleting units.
 */
export function bumpChapterUnitsCount(chapterId, delta = 1) {
  if (!chapterId || !Array.isArray(chaptersCache.chapters)) return;

  const targetId = String(chapterId);

  chaptersCache.chapters = chaptersCache.chapters.map((chapter) => {
    const id = chapter?.id ?? chapter?._id ?? chapter?.chapter_id;
    if (id == null || String(id) !== targetId) return chapter;

    const current =
      coerceNumber(chapter?.lessons_count) ??
      coerceNumber(chapter?.lesson_count) ??
      coerceNumber(chapter?.units_count) ??
      coerceNumber(chapter?.unit_count) ??
      coerceNumber(chapter?.children_count) ??
      coerceNumber(chapter?.child_count) ??
      (Array.isArray(chapter?.lessons) ? chapter.lessons.length : null) ??
      (Array.isArray(chapter?.units) ? chapter.units.length : null) ??
      (Array.isArray(chapter?.children) ? chapter.children.length : null) ??
      0;

    const next = Math.max(0, current + Number(delta || 0));
    return {
      ...chapter,
      lessons_count: next,
      lesson_count: next,
      units_count: next,
      unit_count: next,
      children_count: next,
      child_count: next,
    };
  });
}
